<template>
  <div class="home">
    <pc v-if="show" />
    <wap v-else />
  </div>
</template>

<script>
import pc from "../components/pc_index.vue";
import wap from "../components/wap.vue";
export default {
  name: "HomeView",
  components: {
    pc,
    wap,
  },
  data() {
    return {
      show: true,
    };
  },
  created() {
    let width = window.innerWidth || document.clientWidth;
    let height1 = window.screen.height
    let height2 = window.innerHeight
    console.log(width,'userAgent')
    console.log(height1-height2)
    this.$store.dispatch('initActions')
    this.handleResize();
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      let width = window.innerWidth || document.clientWidth;

      if (width <= 750) {
        this.show = false;
      } else {
        this.show = true;
      }
    },
  },
};
</script>
